import { createFileRoute } from '@tanstack/react-router'
import { MeetingsPage } from '@/features/meetings/components/MeetingsPage'

export const Route = createFileRoute('/_auth/meetings')({
  component: MeetingsPage,
})
